import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useNavigate, useLocation, useParams } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, ListItemButton, CssBaseline, AppBar, Toolbar, Typography, Button, IconButton, Menu, MenuItem, Badge,Divider,useTheme, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircle from '@mui/icons-material/AccountCircle';
import axios from 'axios';
import { io } from 'socket.io-client'; // Socket.IO client import edildi
import Login from './pages/Login';
import Register from './pages/Register';
import ProjectList from './pages/ProjectList';
import ProjectDetails from './pages/ProjectDetails';
import Gantt from './pages/Gantt';
import Notifications from './pages/Notifications';
import CreateProject from './pages/CreateProject';
//import Members from './pages/Members';
import ProjectMembers from './pages/ProjectMembers';
import ProjectTeams from './pages/ProjectTeams';
import AcceptInvite from './pages/AcceptInvite';
import ConfirmEmail from './pages/ConfirmEmail';
import ProtectedLayout from './components/ProtectedLayout';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import Contact from './pages/Contact';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import BlogAdmin from './pages/BlogAdmin';
import Blogs from './pages/Blogs';
import BlogDetails from './pages/BlogDetails';
import GanttWidget from './pages/GanttWidget';
import GanttFreeTool from './pages/GanttFreeTool';
import InstagramAdmin from './pages/InstaAdmin';
import Forum from './pages/Forum';
import Topic from './pages/Topic';

import HomeIcon from '@mui/icons-material/Home';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from "react-i18next";


function App() {
  const { t } = useTranslation();
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [socket, setSocket] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [menuOpen, setMenuOpen] = useState(true);
  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem('selectedMenu') || 'All Projects'
  );
  

  const hideTopBar = ['/login', '/register', '/blog', '/forum'].some(path =>
    location.pathname.startsWith(path)
  ) || 
  location.pathname.startsWith('/topic/') || 
  location.pathname.startsWith('/blog/');
  
  const drawerWidth = hideTopBar ? 0 : (menuOpen ? 240 : 60);

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  const [anchorEltopbar, setAnchorEltopbar] = useState(null);
const isMenuOpen = Boolean(anchorEltopbar);

const theme = useTheme(); // Temayı al
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 'sm' altındaki ekranları tespit et


const handletopMenuOpen = (event) => {
  setAnchorEltopbar(event.currentTarget);
};

const handletopMenuClose = () => {
  setAnchorEltopbar(null);
};

  useEffect(() => {
    // Menüyü her seçimde kaydedin
    localStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);






  // Kullanıcı oturum bilgisini ve geçerliliğini kontrol et
  useEffect(() => {
    const checkSessionValidity = async () => {
      try {
        const token = localStorage.getItem("token");
  
        const exemptedPaths = [
          "/accept-invite",
          "/confirm-email",
          "/topic",
          "/forum",
          "/register",
          "/blogs",
          "/blog",
          "/free-gantt-chart",
          "/api/widget",
          "/gantt-chart",
          "/reset-password",
          "/forgot-password",
          "/locales",
        ];
  
        if (exemptedPaths.some((path) => location.pathname.includes(path))) {
          return;
        }
  
        if (!token) {
          
          setIsLoggedIn(false);
          navigate("/login");
          return;
        }
  
        // 🔥 1️⃣ Fresh profile çek
        const profileRes = await api.get("/api/users/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
  
        const freshUser = profileRes.data;
  
       
  
        localStorage.setItem("profile", JSON.stringify(freshUser));
  
        setUser(freshUser);
        setUsername(freshUser.name);
        setIsLoggedIn(true);
  
        const now = new Date();
        const freeTrialEndDate = freshUser.free_trial_end_date
          ? new Date(freshUser.free_trial_end_date)
          : null;
  
        // 🔹 1️⃣ Lifetime
        if (freshUser.lifetimeAccess) {
          console.log("➡ Lifetime access → allow");
          return;
        }
  
        // 🔹 2️⃣ Free Trial
        if (freeTrialEndDate && now <= freeTrialEndDate) {
          
          return;
        }
  
        // 🔹 3️⃣ Premium
        if (freshUser.isSubscribed || freshUser.subscription_status === "active") {
          
          return;
        }
  
        // 🔹 4️⃣ Backend access check
        const response = await api.post(
          "/api/auth/projectrole3check",
          {}, // body artık boş
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        
  
        if (response.data?.access) {
          
          return;
        }
  
        // 🔹 5️⃣ Access yok → reason map + profile sayfasına yönlendir
        const reason = response.data?.reason;
  
        let popupReason;
        if (reason === "MANAGER_NOT_PREMIUM") {
          popupReason = "manager_inactive";
        } else if (reason === "NO_PROJECTS") {
          popupReason = "no_projects";
        } else {
          popupReason = "premium_required";
        }
  
        
  
        if (location.pathname !== "/profile") {
          navigate("/profile", { state: { accessReason: popupReason } });
        }
  
      } catch (error) {
        const status = error?.response?.status;
  
        
  
        if (status === 401) {
          
          localStorage.removeItem("token");
          localStorage.removeItem("profile");
          setIsLoggedIn(false);
          navigate("/login");
        }
      }
    };
  
    checkSessionValidity();
  }, [location.pathname]);
  
  
  



  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401 && !location.pathname.includes('/accept-invite') && !location.pathname.includes('/confirm-email') && !location.pathname.includes('/register')) {

          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setIsLoggedIn(false);
          console.log("merhaba");
          navigate('/login');
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate, location.pathname]);



  // Socket.io bağlantısını `withCredentials` parametresiyle ayarlayın
  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_API_BASE_URL, {
      withCredentials: true,
    });
    setSocket(newSocket);

    return () => newSocket.close();
  }, [setSocket]);

  useEffect(() => {
    if (user) {
      socket.emit('join', user.id);
      

      socket.on('newNotification', (notification) => {
        
        setUnreadNotificationsCount((prevCount) => prevCount + 1);
      });
    }

    return () => {
      socket && socket.off('newNotification');
    };
  }, [user, socket]);

  // Okunmamış bildirimleri çekme
  useEffect(() => {
    const fetchUnreadNotifications = async () => {
      try {
        const token = localStorage.getItem('token');
        const projectId = params.projectId || location.pathname.split('/')[2];
        if (!projectId) return;
        const response = await api.get(`/api/notifications/unread?projectId=${projectId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUnreadNotificationsCount(response.data.unreadCount || 0);
      } catch (error) {
        
      }
    };

    if (isLoggedIn) {
      fetchUnreadNotifications();
    }
  }, [isLoggedIn, location, params.projectId]);

  const handleLogout = () => {
    if (socket) {
      socket.emit('leave', user.id); // Kullanıcının socket odasından ayrılmasını iste
      socket.disconnect(); // Soketi tamamen kapat
    }

    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsLoggedIn(false);
    navigate('/login');
  };


  const renderDynamicButton = () => {
    const projectId = params.projectId || location.pathname.split('/')[2];
    const dashboardPath = `/projects/${projectId}`;
    const otherPaths = ['/gantt/', '/notifications', '/projectteams', '/projectmembers'];

    if (location.pathname === dashboardPath) {
      return (
        <Button variant="contained" className="action-button" onClick={() => navigate(`/gantt/${projectId}`)}>
          Go to Gantt Chart
        </Button>
      );
    } else if (otherPaths.some(path => location.pathname.includes(path))) {
      return (
        <Button variant="contained" className="action-button" onClick={() => navigate(dashboardPath)}>
          Go to Dashboard
        </Button>
      );
    }
    return null;
  };


  const menuItemStyles = {
    '&.Mui-selected': {
      backgroundColor: '#48484a',
      color: 'white',
      '&:hover': {
        backgroundColor: '#5e5bf7',
      },
    },
  };
  
  // `Drawer` Menüsünü dinamik olarak oluşturma
  const projectId = params.projectId || location.pathname.split('/')[2];

  const menuItems = [
    { text: t('menu.allProjects'), icon: <HomeIcon />, path: '/projects' },
    { text: t('menu.profile'), icon: <AccountCircle />, path: '/profile' },
    { text: t('menu.contactSupport'), icon: <ContactSupportIcon />, path: '/contact' },
  ];
  
  // Eğer proje sayfalarındaysa dinamik öğeleri ekle
  const dynamicMenuItems = projectId
    ? [
        { text: t('menu.projectDashboard'), icon: <SpaceDashboardIcon />, path: `/projects/${projectId}` },
        { text: t('menu.ganttChart'), icon: <ViewTimelineIcon />, path: `/gantt/${projectId}` },
        { text: t('menu.projectMembers'), icon: <GroupIcon />, path: `/projectmembers/${projectId}` },
        { text: t('menu.projectTeams'), icon: <GroupsIcon />, path: `/projectteams/${projectId}` },
        {
          text: t('menu.notifications'),
          icon: (
            <Badge badgeContent={unreadNotificationsCount} color="error">
              <NotificationsIcon />
            </Badge>
          ),
          path: `/notifications/${projectId}`,
        },
        { type: 'divider' }, // Listenin sonuna divider ekleniyor
      ]
    : [];

    // Üst Menü İçin Özel Öğeler
const topMenuItems = [
  { text: t("menu.discover"), url: "https://www.ganttmaster.com", external: true },
  { text: t("menu.forum"), path: "/forum" },
  { text: t("menu.blog"), path: "/blog" },
];


  
  // Birleştirilmiş menü öğeleri
  const combinedMenuItems = [...dynamicMenuItems,...menuItems ];

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };



  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  function RedirectToHome() {
    React.useEffect(() => {
      window.location.href = "https://ganttmaster.com";
    }, []);
    return null;
  }
  



  return (
    <div className="App">
      <CssBaseline />
      <AppBar position="fixed" className="top-bar" style={{ backgroundColor: '#282c34',zIndex: 1201 }}>
        <Toolbar>
          {/* Logo */}

          <div  onClick={() => window.location.href = 'https://www.ganttmaster.com'}  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo10.png`}
              alt="GanttMaster Logo"
              style={{ height: '40px', marginRight: '10px' }}
            />

          </div>

          {/* Boşluk: Öğeleri sağa yaslamak için */}
          <div style={{ flexGrow: 1 }} />
           {/* Ekran genişliği kontrolü */}
    {!isMobile  ? (
      <>
       {/* Üst Menü Butonları */}
    {topMenuItems.map((item, index) => (
      <Button
        key={index}
        color="inherit"
        onClick={() => {
          if (item.external) {
            window.location.href = item.url;
          } else {
            navigate(item.path);
          }
        }}
        style={{ marginRight: "15px", fontWeight: "bold", color: "#FFFFFF" }}
      >
        {item.text}
      </Button>
    ))}
      </>
    ) : (
      <>
        {/* Dropdown Menüsü */}
        <IconButton color="inherit" onClick={handletopMenuOpen} style={{ marginRight: '10px' }}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEltopbar}
          open={isMenuOpen}
          onClose={handletopMenuClose}
          PaperProps={{
            style: {
              backgroundColor: '#343943',
              color: '#FFFFFF',
            },
          }}
        >
          <MenuItem
            onClick={() => {
              window.location.href = 'https://www.ganttmaster.com';
              handletopMenuClose();
            }}
          >
            {t("menu.discover")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate('/forum');
              handletopMenuClose();
            }}
          >
            {t("menu.forum")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate('/blog');
              handletopMenuClose();
            }}
          >
            {t("menu.blog")}
          </MenuItem>
        </Menu>
      </>
    )}


          {/* Giriş Yapmış Kullanıcı Menüsü */}
          {isLoggedIn ? (
            <>
              

              {/* Hesap Menüsü */}
              <IconButton color="inherit" onClick={handleMenuOpen} style={{ marginRight: '10px' }}>
                <AccountCircle />
              </IconButton>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <Typography variant="subtitle1" sx={{ padding: '10px' }}>
                {t("menu.welcome")}, {username}
                </Typography>
                <MenuItem onClick={() => navigate('/projects')}>{t("menu.allProjects")}</MenuItem>
                <MenuItem onClick={() => navigate('/profile')}>{t("menu.profile")}</MenuItem>
                <MenuItem onClick={() => navigate('/contact')}>{t("menu.contactSupport")}</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>
            </>
          ) : (
            // Giriş Yapmamış Kullanıcı Butonları
            <>
              
              <Button
                variant="contained"
                onClick={() => navigate('/login')}
                style={{
                  backgroundColor: '#807efe',
                  color: '#FFFFFF',
                  display: "none"
                }}
              >
                {t("menu.login")}
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>


      {/* Drawer Bileşeni */}
      {!hideTopBar && (
      <Drawer
      variant="permanent"
      anchor="left"
      open={menuOpen}
      onClose={toggleMenu}
      PaperProps={{
        style: {
          width: drawerWidth,
          transition: 'width 0.3s',
          backgroundColor: '#343943',
          color: '#FFFFFF',
          overflowX: 'hidden',
          
        },
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '10px',
          marginTop: '64px',
        }}
      >
        <List>
  {/* Menü Aç/Kapat Düğmesi */}
  <IconButton onClick={toggleMenu} style={{ color: 'white' }}>
    {menuOpen ? <ChevronLeftIcon /> : <MenuIcon />}
  </IconButton>

  {/* Menü Öğeleri */}
  {combinedMenuItems.map((item, index) =>
    item.type === 'divider' ? (
      <Divider
        key={`divider-${index}`}
        style={{ backgroundColor: '#555555', margin: '10px 0' }}
      />
    ) : (
      <ListItem
        button
        key={item.text}
        selected={selectedMenu === item.text}
        onClick={() => {
          setSelectedMenu(item.text);
          navigate(item.path);
        }}
        style={{ color: '#FFFFFF' }}
      >
        {item.icon}
        {menuOpen && <ListItemText primary={item.text} style={{ marginLeft: 10 }} />}
      </ListItem>
    )
  )}
</List>

        <Divider />
      </div>
    </Drawer>
    
      )}

      <main style={{
          flexGrow: 1,
          marginLeft: drawerWidth,
          padding: '16px',
          transition: 'margin-left 0.3s',
        }} className="main-content">
        <Toolbar />
        <Routes>
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/free-gantt-chart" element={<GanttWidget />} />
          <Route path="/gantt-chart/:code" element={<GanttFreeTool />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/blog/:lang?/:slug" element={<BlogDetails />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/topic/:idSlug" element={<Topic />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/login" element={<Login setUser={setUser} setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/register" element={<RedirectToHome />} />

          <Route path="/accept-invite/:token" element={<AcceptInvite></AcceptInvite>} />
          <Route path="/confirm-email/:token" element={<ConfirmEmail></ConfirmEmail>} />


          <Route element={<ProtectedLayout />}>
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/projects/:projectId" element={<ProjectDetails />} />
            <Route path="/gantt/:projectId" element={<Gantt />} />
            <Route path="/projectteams/:projectId/" element={<ProjectTeams />} />
            <Route path="/projectmembers/:projectId/" element={<ProjectMembers />} />
            <Route path="/notifications/:projectId" element={<Notifications />} />
            <Route path="/createproject" element={<CreateProject />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/blogadmin" element={<BlogAdmin />} />
            <Route path="/instaadmin" element={<InstagramAdmin />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

function RootApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default RootApp;